export default "__VITE_ASSET__Bk7lycRI__"